import styled from 'styled-components'

const StyledChatHistoryList = styled.div`
  border-radius: 12px;
  background-color: ${({ theme }) => theme.color.gray[100]};
`

export default StyledChatHistoryList
